// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__MdVpf","additionalInfo":"AgreementModal_additionalInfo__3yK9M"};